/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  TagsDevicesInput,
  CertifiedPlantType,
} from '..';
import {
  serializeTagsDevicesInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface ImportCertifiedPlantInput {
  plantId: string;
  plantName: string;
  tagsDevices?: TagsDevicesInput[];
}
const build = (_query: DocumentNode, input: ImportCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.plantName !== undefined ? `$plantName: String = ${JSON.stringify(input.plantName).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.tagsDevices !== undefined ? `$tagsDevices:  [ TagsDevicesInput ]  = ${'[' + input.tagsDevices.map((item) => serializeTagsDevicesInput(item)).join(",") + ']'}` : '' ) + `){
    importCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.plantName !== undefined ? 'plantName: $plantName,' : '' } 
      ${ input.tagsDevices !== undefined ? 'tagsDevices: $tagsDevices,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class ImportCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: ImportCertifiedPlantInput): Promise<apollo.FetchResult< { importCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ importCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
